<template>
<div class="chapter">
<div class="inner_page">
<figure>
<p class="image2"><span class="right_1" epub:type="pagebreak" id="page_8" title="8"><img alt="Packinghouse workers, Buenos Amigos..." height="387" src="images/f0008-01.jpg" width="466"/></span></p>
</figure>
<p class="caption">Packinghouse workers, Buenos Amigos Plantation, El Progreso, Yoro, Honduras, September 2004</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Image3.vue?aecaec46